export default __webpack_public_path__ + "static/i-MedicalCard Elite_PDS-68a16394e11fd50759fe73ae5e4ef5f2.pdf";